
export const traducirRelacion = (relacion: string) => {
    switch (relacion) {
      case 'ACTED_IN':
        return 'Actor/Actriz';
      case 'DIRECTED':
        return 'Dirigido/a';
      case 'PRODUCED':
        return 'Producido/a';
      case 'WROTE':
        return 'Escritor';
      case 'FOLLOWS':
        return 'Seguimientos';
      case 'REVIEWED':
        return 'Revisiones';
      case '':
        return '';
      default:
        return 'Desconocido';
    }
  }
  export const reTraduccion = (relacion: string) => {
    switch (relacion) {
      case 'Actor/Actriz':
        return 'ACTED_IN';
      case 'Dirigido/a':
        return 'DIRECTED';
      case 'Producido/a':
        return 'PRODUCED';
      case 'Escritor':
        return 'WROTE';
      case 'Seguimientos':
        return 'FOLLOWS';
      case 'Revisiones':
        return 'REVIEWED';
      case '':
        return '';
      default:
        return 'UNKNOWN';
    }
  }